// Shared pill className string for tags.
export const pill =
  "inline-flex items-center rounded-full border px-2 py-0.5 text-xs leading-5";
